"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrushingSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var getPointerSelector = function (state) { return state.interactions.pointer; };
exports.isBrushingSelector = re_reselect_1.default([getPointerSelector], function (pointer) {
    return pointer.dragging;
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=is_brushing.js.map